import { defineStore } from "pinia";

export const useToasterStore = defineStore("toaster", {
  state: () => ({
    _toasts: [],
    _blockingModal: null,
  }),
  getters: {
    toasts: (state) => state._toasts,
    blockingModal: (state) => state._blockingModal,
  },
  actions: {
    addToast({ title, message, type = "danger", duration = 5000 }) {
      const id = Date.now();
      this._toasts.push({ id, title, message, type, duration });
      if (duration > 0) {
        setTimeout(() => this.removeToast(id), duration);
      }
    },
    showBlockingModal({
      title,
      message,
      type = "danger",
      primaryLabel,
      onPrimary,
    }) {
      this._blockingModal = { title, message, type, primaryLabel, onPrimary };
    },
    closeBlockingModal() {
      this._blockingModal = null;
    },
    removeToast(id) {
      this._toasts = this._toasts.filter((toast) => toast.id !== id);
    },
  },
});
